import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { setExpanded } from '../utils/dom'

gsap.registerPlugin(ScrollTrigger)

let articleController = null
let matchMediaInstances = []

export default function initArticle() {
	matchMediaInstances.forEach((mm) => mm.revert())
	matchMediaInstances = []

	articleController?.abort()
	articleController = new AbortController()
	const { signal } = articleController

    // MARK: Toggle menu for smaller screens
    const articles = document.querySelectorAll('.article')

    articles.forEach(article => {

        const articleNav = article.querySelector('.article__nav')

		if (articleNav) {

			const articleNavList = articleNav.querySelector('.article__nav-list')
			const articleNavLinks = articleNav.querySelectorAll('.page-nav-link')
			const toggle = articleNav.querySelector('.article__nav-toggle')

			if (!articleNavList || !toggle) return

			let mm = gsap.matchMedia()
			matchMediaInstances.push(mm)

			const openMenu = (el) => {
				el.setAttribute('data-menu-state', 'open')
				setExpanded(toggle, true)
			}

			const closeMenu = (el) => {
				el.setAttribute('data-menu-state', 'closed')
				setExpanded(toggle, false)
			}

			mm.add("(max-width: 959px)", () => {

				const handleToggleClick = () => {
					const state = articleNav.getAttribute('data-menu-state')

					if (state === "open") {
						closeMenu(articleNav)
					} else {
						openMenu(articleNav)
					}
				}

				const handleDocumentClick = (e) => {
					const clickedInsideDropdown = articleNavList.contains(e.target)
					const clickedToggle = toggle.contains(e.target)

					if (!clickedInsideDropdown && !clickedToggle) {
						const state = articleNav.getAttribute('data-menu-state')

						if (state === "open") {
							closeMenu(articleNav)
						}
					}
				}

				const handleResize = () => {
					const state = articleNav.getAttribute('data-menu-state')

					if (state === "open") {
						closeMenu(articleNav)
					}
				}

				const handleEscape = (event) => {
					if (event.key === 'Escape') {
						closeMenu(articleNav)
					}
				}

				const handleNavLinkClick = () => {
					closeMenu(articleNav)
				}

				toggle.addEventListener('click', handleToggleClick, { signal })
				document.addEventListener('click', handleDocumentClick, { signal })
				document.addEventListener('keydown', handleEscape, { signal })
				window.addEventListener('resize', handleResize, { signal })

				articleNavLinks.forEach(link => {
					link.addEventListener('click', handleNavLinkClick, { signal })
				})

				// Hide nav when outside FAQ section
				const navVisibilityTrigger = ScrollTrigger.create({
					trigger: article,
					start: 'top bottom',
					end: 'bottom bottom',
					onEnter: () => {
						articleNav.classList.add('is-shown')
					},
					onEnterBack: () => {
						articleNav.classList.add('is-shown')
					},
					onLeave: () => {
						articleNav.classList.remove('is-shown')
						const state = articleNav.getAttribute('data-menu-state')
						if (state === "open") {
							closeMenu(articleNav)
						}
					},
					onLeaveBack: () => {
						articleNav.classList.remove('is-shown')
						const state = articleNav.getAttribute('data-menu-state')
						if (state === "open") {
							closeMenu(articleNav)
						}
					},
				})

				// CLEANUP
				return () => {
					toggle.removeEventListener('click', handleToggleClick)
					document.removeEventListener('click', handleDocumentClick)
					document.removeEventListener('keydown', handleEscape)
					window.removeEventListener('resize', handleResize)
					articleNavLinks.forEach(link => {
						link.removeEventListener('click', handleNavLinkClick)
					})
					navVisibilityTrigger.kill()
					closeMenu(articleNav)
				}
			})

			closeMenu(articleNav)
		}
	})

}
